import React from "react";
import Header from "../../Layout/Header";
import HeaderLayout from "../../Layout/HeaderLayout";
import { useLocation } from "react-router-dom";

const Dashboard = ({setSelectNetwork, setImportWallet}) => {
  return (
    <div className="bg-[#060606] relative h-screen overflow-hidden overflow-y-auto text-white font-poppins ">
      {/* <HeaderLayout  /> */}
      <div
        className=" absolute -top-[20rem] left-0 right-0 w-[90%] mx-auto h-screen opacity-30 "
        style={{
          background:
            "radial-gradient(50% 50% at 50% 50%, #FFF2C2 0%, rgba(0, 0, 0, 0) 100%)",
        }}
      ></div>
      <h1 className="pt-14 text-center text-3xl sm:text-5xl lg:text-6xl font-Artemus ">
        Build the Future
        <br />
        with Exchange
      </h1>
      <p className=" text-center text-sm mt-5 text-[#D3D3D6] ">
        Discover how we can help you connect with the next generation of the
        internet.
      </p>
      <div className=" -translate-y-10 ">
        <div className="flex items-center relative">
          <img src="../assets/other/dashboard1.svg" />
          <img
            src="../assets/other/dashboard1.svg"
            className=" scale-x-[-1] "
          />
          <div
            className="w-[70%] absolute left-0 right-0 h-96 opacity-10 "
            style={{
              background:
                "radial-gradient(50% 50% at 50% 50%, rgba(255, 242, 194, 0.44) 0%, rgba(0, 0, 0, 0) 100%)",
            }}
          ></div>
          <div className="mt-10 md:mt-0 absolute w-full flex md:flex-row flex-col justify-center items-center   mb-4 md:gap-10 gap-3">
            {/* <button onClick={()=>setCreateWallet(true)} className="text-black font-semibold text-sm md:text-base px-10 py-2 rounded-full bg-[#FFFFD9] border-2 border-black/20 ">
              Create Wallet
            </button> */}
            <button onClick={()=>setSelectNetwork(true)} className="font-semibold text-sm md:text-base px-10 py-2 rounded-full bg-[#FFFFD9] text-black border-[#FFFFD9] border-2">
              Choose Wallet
            </button>
            <button onClick={()=>setImportWallet(true)} className="font-semibold text-sm md:text-base px-10 py-2 rounded-full border-[#FFFFD9] border-2">
              Import Wallet
            </button>
          </div>
        </div>
      </div>

      <div className="lg:w-[80%] w-[90%] mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-10 pb-20">
        <div>
          <div className="flex gap-2 items-center mb-3">
            <img src="../assets/other/dashboard2.svg" />
            <p className=" font-semibold ">Cross-Chain Access</p>
          </div>
          <p className="text-[#D3D3D6] text-sm">
            Seamlessly interact with diverse blockchain networks.
          </p>
        </div>
        <div>
          <div className="flex gap-2 items-center mb-3">
            <img src="../assets/other/dashboard3.svg" />
            <p className=" font-semibold ">Decentralized Identity</p>
          </div>
          <p className="text-[#D3D3D6] text-sm">
            Securely manage your digital identity across applications.
          </p>
        </div>
        <div>
          <div className="flex gap-2 items-center mb-3">
            <img src="../assets/other/dashboard4.svg" />
            <p className=" font-semibold ">Smart Contract Automation</p>
          </div>
          <p className="text-[#D3D3D6] text-sm">
            Streamline operations with automated smart contracts.
          </p>
        </div>
        <div>
          <div className="flex gap-2 items-center mb-3">
            <img src="../assets/other/dashboard5.svg" />
            <p className=" font-semibold ">Community Governance</p>
          </div>
          <p className="text-[#D3D3D6] text-sm">
            Participate in decentralized decision-making through voting.
          </p>
        </div>
        <div>
          <div className="flex gap-2 items-center mb-3">
            <img src="../assets/other/dashboard6.svg" />
            <p className=" font-semibold ">Asset Tokenization</p>
          </div>
          <p className="text-[#D3D3D6] text-sm">
            Digitally tokenize real-world assets for efficient management.
          </p>
        </div>
        <div>
          <div className="flex gap-2 items-center mb-3">
            <img src="../assets/other/dashboard7.svg" />
            <p className=" font-semibold ">Interoperable Data Exchange</p>
          </div>
          <p className="text-[#D3D3D6] text-sm">
            Exchange data seamlessly between applications for collaboration.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;